import { render, staticRenderFns } from "./PageNavigator.vue?vue&type=template&id=3744edfd&"
import script from "./PageNavigator.vue?vue&type=script&lang=js&"
export * from "./PageNavigator.vue?vue&type=script&lang=js&"
import style0 from "./PageNavigator.vue?vue&type=style&index=0&lang=css&"
import style1 from "./PageNavigator.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBadge,VBtn,VCard,VCardText,VHover,VIcon,VImg,VMenu})
